import { useEditMode } from "./EditModeContext";
import { Pencil, Check } from "lucide-react";

export default function EditModeToggle() {
  const { isAdmin, editMode, toggleEditMode } = useEditMode();

  if (!isAdmin) return null;

  return (
    <div className="fixed bottom-20 right-6 z-[999] flex items-center gap-2" data-testid="edit-mode-toggle">
      {editMode && (
        <span className="bg-wc-brass text-white text-xs font-body px-3 py-1.5 rounded-full shadow-lg animate-pulse">
          Editing — click any text
        </span>
      )}
      <button
        onClick={toggleEditMode}
        className={`w-12 h-12 rounded-full shadow-xl flex items-center justify-center transition-all duration-300 ${
          editMode
            ? "bg-wc-brass text-white scale-110"
            : "bg-wc-forest text-wc-cream hover:bg-wc-teal"
        }`}
        title={editMode ? "Done editing" : "Edit site"}
      >
        {editMode ? <Check className="w-5 h-5" /> : <Pencil className="w-5 h-5" />}
      </button>
    </div>
  );
}
